import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/service/auth/user.service';

@Component({
    selector: 'app-user-edit',
    templateUrl: './user-edit.component.html',
    styles: []
})
export class UserEditComponent implements OnInit {
    constructor(
        private userService: UserService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    id: string;
    host: string;
    isChangePassword: boolean = false;
    user: any = {};

    ngOnInit() {
        this.id = this.route.snapshot.paramMap.get('id');
        this.host = this.userService.BaseHost;

        if (this.id)
            this.loadData();
    }

    loadData() {
        this.userService.getUserById(this.id).subscribe(
            res => {
                if (!res)
                    this.router.navigateByUrl('/techbyte/admin/error');

                this.user = <any>res;
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onRefresh() {
        this.loadData();
    }

    onSave() {
        document.getElementById('page-loader-data').style.display = "block";
        this.user.isChangePassword = this.isChangePassword;
        this.userService.saveUser(this.user).subscribe(
            res => {
                this.toastr.success("Thành công");
                this.router.navigateByUrl('/techbyte/admin/user');
                document.getElementById('page-loader-data').style.display = "none";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader-data').style.display = "none";
            },
        );
    }

    onAuthorized(authorizedStatus: number) {
        document.getElementById('page-loader-data').style.display = "block";
        this.user.authorizedStatus = authorizedStatus;
        this.userService.authorizedUser(this.user).subscribe(
            res => {
                this.toastr.success("Thành công");
                window.location.reload();
                document.getElementById('page-loader-data').style.display = "none";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader-data').style.display = "none";
            },
        );
    }

    onCancel() {
        this.router.navigateByUrl('/techbyte/admin/user');
    }

    onChangePassword() {
        this.isChangePassword = !this.isChangePassword;
    }
}